import {api} from "@/api";

// 获取操作日志列表
export const getLogApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/systemLog/page',
        method: 'POST',
        data: data
    })
}